export default __webpack_public_path__ + "static/media/logo192x192.0c4daa02.png";